import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { offerActionTypes } from './Constants';
import { EVENTS_TYPES } from '../../pagesNext/shared/Constants';
import * as errorHandlerActions from '../../components/errorHandler/Actions';
import * as offerActions from './Actions';
import * as sharedActions from '../../pagesNext/shared/Actions';

export default function* () {
	yield all([
		yield takeLatest(offerActionTypes.OFFER_REQUEST, handleOfferRequest),
		yield takeLatest(offerActionTypes.GET_FULL_ADDRESS, handleGetAddressRequest),
		yield takeLatest(offerActionTypes.GET_OFFER_ABILITY, handleGetOfferAbility),
		yield takeLatest(
			offerActionTypes.ACCEPT_REVERSE_TRIAL_OFFER_REQUEST,
			handleAcceptReverseTrialOffer,
		),
	]);
}

export function* handleGetOfferAbility({ payload }) {
	try {
		const { data: offer_identifier } = payload;

		const { data } = yield call(processRequest, `user_accepted_offers/check`, 'GET', {
			offer_identifier,
		});

		if (data && data.applicable) {
			yield put(offerActions.getOfferAbilitySuccess(data));
			yield put(
				sharedActions.sendEventRequest({
					event_name: EVENTS_TYPES.OFFER_VIEWED,
					offer_identifier,
				}),
			);
		} else {
			yield put(offerActions.getOfferAbilityError(data));
			yield put(offerActions.offerRequestError());
		}
	} catch (e) {
		yield put(offerActions.getOfferAbilityError(null));
		yield put(offerActions.offerRequestError());
		yield put(errorHandlerActions.handleError(e));
	}
}

export function* handleGetAddressRequest({ payload }) {
	try {
		const { data: formData } = payload;

		const { data } = yield call(processRequest, 'addresses/search', 'GET', formData);

		yield put(offerActions.getFullAddressSuccess(data));
	} catch (e) {
		yield put(offerActions.getFullAddressError());
	}
}

export function* handleOfferRequest({ payload }) {
	try {
		const { data: formData } = payload;

		yield call(processRequest, 'user_accepted_offers', 'POST', formData);

		yield put(offerActions.offerRequestSuccess());
	} catch (e) {
		yield put(offerActions.offerRequestError());
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}

export function* handleAcceptReverseTrialOffer() {
	try {
		yield call(processRequest, 'user_accepted_offers/accept_offer', 'POST', {
			offer: 'reverse-trial',
		});
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}
